var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-icon",class:{ 'rounded-circle': _vm.circle, 'rounded': !_vm.circle },style:({ width: _vm.size, height: _vm.size })})
}
var staticRenderFns = []

export { render, staticRenderFns }